import { Box, Grid, Typography } from "@mui/material";
import { NWONProcessStepsProps } from "./NWONProcessStepsInterfaces";
import { useNWONProcessStepsStyles } from "./NWONProcessStepsStyles";

export const NWONProcessSteps = (props: NWONProcessStepsProps): JSX.Element => {
  const { classes } = useNWONProcessStepsStyles();

  return (
    <Box className={classes.wrapper}>
      <Grid container={true}>
        {props.steps.map((step) => {
          return (
            <Grid
              key={step.text}
              className={classes.itemWrapper}
              item={true}
              md={4}
              sm={12}
            >
              <Box className={classes.icon}>{step.icon}</Box>

              <Typography variant="h4" component="h3">
                {step.headline}
              </Typography>

              <Box className={classes.text}>{step.text}</Box>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};
